import { IFilter } from "@saleor/components/Filter";
import { FilterOpts, MinMax } from "@saleor/types";
import {
  DiscountStatusEnum,
  VoucherDiscountType,
  VoucherTypeEnum
} from "@saleor/types/globalTypes";
import {
  createDateField,
  // createNumberField,
  createOptionsField
} from "@saleor/utils/filters/fields";
import { defineMessages, IntlShape } from "react-intl";

export enum VoucherFilterKeys {
  discountType = "discountType",
  started = "started",
  status = "status",
  specificInformation = "specificInformation"
  // timesUsed = "timesUsed"
}

export interface VoucherListFilterOpts {
  discountType: FilterOpts<VoucherDiscountType[]>;
  started: FilterOpts<MinMax>;
  status: FilterOpts<DiscountStatusEnum[]>;
  specificInformation: FilterOpts<VoucherTypeEnum[]>;
  // timesUsed: FilterOpts<MinMax>;
}

const messages = defineMessages({
  active: {
    defaultMessage: "Active",
    description: "voucher status"
  },
  capped: {
    defaultMessage: "Capped and Percentage",
    description: "voucher status"
  },
  deactivated: {
    defaultMessage: "Deactivated",
    description: "voucher status"
  },
  entireOrder: {
    defaultMessage: "Entire order",
    description: "voucher specific information"
  },
  evoucher: {
    defaultMessage: "E-Voucher",
    description: "voucher type"
  },
  expired: {
    defaultMessage: "Expired",
    description: "voucher status"
  },
  fixed: {
    defaultMessage: "Fixed amount",
    description: "discount type"
  },
  percentage: {
    defaultMessage: "Percentage",
    description: "discount type"
  },
  scheduled: {
    defaultMessage: "Scheduled",
    description: "voucher status"
  },
  shipping: {
    defaultMessage: "Free Shipping",
    description: "discount type"
  },
  specificProducts: {
    defaultMessage: "Specific products",
    description: "voucher specific information"
  },
  started: {
    defaultMessage: "Date Range",
    description: "voucher start date"
  },
  status: {
    defaultMessage: "Voucher Status",
    description: "voucher status"
  },
  timesUsed: {
    defaultMessage: "Times used",
    description: "voucher"
  },
  type: {
    defaultMessage: "Discount Type"
  },
  voucherSpecificInformation: {
    defaultMessage: "Voucher Specific Information",
    description: "voucher specific information"
  }
});

export function createFilterStructure(
  intl: IntlShape,
  opts: VoucherListFilterOpts
): IFilter<VoucherFilterKeys> {
  return [
    {
      ...createDateField(
        VoucherFilterKeys.started,
        intl.formatMessage(messages.started),
        opts.started.value
      ),
      active: opts.started.active
    },
    // {
    //   ...createNumberField(
    //     VoucherFilterKeys.timesUsed,
    //     intl.formatMessage(messages.timesUsed),
    //     opts.timesUsed.value
    //   ),
    //   active: opts.timesUsed.active
    // },
    {
      ...createOptionsField(
        VoucherFilterKeys.status,
        intl.formatMessage(messages.status),
        opts.status.value,
        true,
        [
          {
            label: intl.formatMessage(messages.active),
            value: DiscountStatusEnum.ACTIVE
          },
          {
            label: intl.formatMessage(messages.expired),
            value: DiscountStatusEnum.EXPIRED
          },
          {
            label: intl.formatMessage(messages.scheduled),
            value: DiscountStatusEnum.SCHEDULED
          },
          {
            label: intl.formatMessage(messages.deactivated),
            value: DiscountStatusEnum.INACTIVE
          }
        ]
      ),
      active: opts.status.active
    },
    {
      ...createOptionsField(
        VoucherFilterKeys.discountType,
        intl.formatMessage(messages.type),
        opts.discountType.value,
        false,
        [
          {
            label: intl.formatMessage(messages.fixed),
            value: VoucherDiscountType.FIXED
          },
          {
            label: intl.formatMessage(messages.percentage),
            value: VoucherDiscountType.PERCENTAGE
          },
          {
            label: intl.formatMessage(messages.shipping),
            value: VoucherDiscountType.SHIPPING
          },
          {
            label: intl.formatMessage(messages.capped),
            value: VoucherDiscountType.PERCENTAGE_AND_CAPPED
          },
          {
            label: intl.formatMessage(messages.evoucher),
            value: VoucherDiscountType.E_VOUCHER
          }
        ]
      ),
      active: opts.discountType.active
    },
    {
      ...createOptionsField(
        VoucherFilterKeys.specificInformation,
        intl.formatMessage(messages.voucherSpecificInformation),
        opts.specificInformation.value,
        false,
        [
          {
            label: intl.formatMessage(messages.entireOrder),
            value: VoucherTypeEnum.ENTIRE_ORDER
          },
          {
            label: intl.formatMessage(messages.specificProducts),
            value: VoucherTypeEnum.SPECIFIC_PRODUCT
          }
        ]
      ),
      active: opts.specificInformation.active
    }
  ];
}
